// @flow

import React from 'react';

import ServiceUtils from 'app/service/ServiceUtils';
import { WithAllServices } from '@zapier/services';

import type { ComponentType, Node } from 'react';

import type { Service } from 'app/service/types';

type Props = {
  children: (result: {
    services: { [string]: Service },
    loading: boolean,
    error: ?Error,
  }) => Node,
};

const WithAllServicesById = (props: Props) => {
  return (
    <WithAllServices>
      {({ error, loading, services }) => {
        const allServicesById = ServiceUtils.getServicesById(services);

        return props.children({ error, loading, services: allServicesById });
      }}
    </WithAllServices>
  );
};

// hoc'ified `WithAllServicesById` for compatibility with legacy code
export const withAllServicesById = (WrappedComponent: ComponentType<any>) => {
  return (props: *) => (
    <WithAllServicesById>
      {childProps => {
        return <WrappedComponent {...props} {...childProps} />;
      }}
    </WithAllServicesById>
  );
};
